var render = function render(){var _vm=this,_c=_vm._self._c;return _c('what-is-modal',{ref:"whatIsNumberModal",attrs:{"img-src":`${_vm.config.baseUri}/images/supercharged/giftcard-example.png`,"sub-text":"Please note, if the Gift Card was purchased online, the Gift Card number can be found in the email that was sent after the purchase was done or under the 'My Gift Cards' section of your Account."}})
}
var staticRenderFns = []

export { render, staticRenderFns }